export enum PrintCardSize {
  DefaultSize_Custom_2x2 = 'DefaultSize_Custom2x2',
  DefaultSize_Custom_3x4 = 'DefaultSize_Custom3x4',
  DefaultSize_Custom_5x5 = 'DefaultSize_Custom5x5',
  DefaultSize_AddressCard_1x3 = 'DefaultSize_AddressCard',
  DefaultSize_BusinessCard_2x3 = 'DefaultSize_BusinessCard',
  DefaultSize_CustomLabel_2x4 = 'DefaultSize_CustomLabel2x4',
  DefaultSize_IndexCard_3x5 = 'DefaultSize_IndexCard',
  DefaultSize_PostCard_4x6 = 'DefaultSize_PostCard',
  PrintLabelSize_Avery_94200 = 'PrintLabelSize_Avery94200' // 1" x 2-5/8" (Avery 94200)
}
